<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3 class="txtbienvenida">
        Consultar desembolso
        <span class="txtbienvenida-2">Aliado Financiero</span>
      </h3>
    </div>
  </div>
  <div class="container mt-4">
    <form [formGroup]="consultaSolicitudesForm" (ngSubmit)="consultarSolicitudesForm()">
      <div class="row myForm">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                    <div class="mb-3 form-label" [ngClass]="{
              err: isValidFieldConsultaSolicitudesForm('monto')
            }">
            <label for="monto" class="form-label">Monto aprobado</label>
                        <input type="text" [maxlength]="LONGITUD_MAXIMA_MONTO" class="form-control" [ngClass]="{
                'is-invalid': isValidFieldConsultaSolicitudesForm('monto')
              }" formControlName="monto" appOnlyNumbers/>
              <div class="invalid-feedback">Solo numeros</div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                    <div class="mb-3 form-label" [ngClass]="{
              'is-invalid':
                isValidFieldConsultaSolicitudesForm('origenRecursos')
            }">
              <label for="origen" class="form-label">Origen de los recursos</label>
              <select #orig id="orig" class="form-control" formControlName="origenRecursos" title="Seleccione...">
                <option value="">Seleccione...</option>
                <option value="RECURSOS_PROPIOS">Recursos propios</option>
                <option value="RECURSOS_BANCOLDEX">Recursos bancoldex</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row myForm">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                    <div class="mb-3 form-label" [ngClass]="{
              err: isValidFieldConsultaSolicitudesForm('fechaInicial')
            }">
              <label for="fechaInicial" class="form-label">Fecha inicial de creación solicitud</label
                >
                <input
                  type="date"
                  class="form-control"
              [ngClass]="{
                'is-invalid':
                  isValidFieldConsultaSolicitudesForm('fechaInicial')
              }"
                  formControlName="fechaInicial"
                  (change)="validarFechas()"
                  min="1950-01-01" max="{{fechaActual}}"
                  />
                  <div class="invalid-feedback">
                    La fecha incial no puede ser menor a la fecha final.
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                <div
                  class="mb-3 form-label"
            [ngClass]="{
              err: isValidFieldConsultaSolicitudesForm('fechaFinal')
            }"
                  >
                  <label for="fechaFinal" class="form-label"
                    >Fecha final de creación solicitud</label
                    >
                    <input
                      type="date"
                      class="form-control"
              [ngClass]="{
                'is-invalid': isValidFieldConsultaSolicitudesForm('fechaFinal')
              }"
                      formControlName="fechaFinal"
                      (change)="validarFechas()"
                      min="obtenerValorCampo('fechaInicial')"
                      required
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-md-center g-3">
                  <div class="col-12 col-md-2 container-btn">
          <button class="btn btn-primary" style="width: 180px;" type="submit" [ngClass]="{
                    'hvr-shrink': consultaSolicitudesForm.valid && cualquierCampoIngresado()}">
                      Consultar
                    </button>
                  </div>
                  <div class="col-12 col-md-2 container-btn">
                    <button class="btn btn-primary hvr-shrink" type="button" style="width: 180px;" (click)="limpiarFormulario()">
                      Limpiar filtros
                    </button>
                  </div>
                  <div class="col-12 col-md-2 container-btn">
                    <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
                      Volver
                    </button>
                  </div>
                </div>
                @if (consulta) {
                  <div class="row justify-content-md-center g-3 mt-2">
                    <div class="col-12 col-md-3 container-btn">
                      <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(true)">
                        Exportar a Excel
                      </button>
                    </div>
                    <div class="col-12 col-md-3 container-btn">
                      <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(false)">
                        Exportar a txt
                      </button>
                    </div>
                  </div>
                }
              </form>
              @if (consulta) {
                <div class="row pr-3 pl-3">
                  <div class="table-responsive">
                    <table class="table table-striped table-borderless rounded">
                      <thead class="table_head">
                        <tr>
                          <th scope="col" class="no-styles table-header">
                            Número de solicitud
                          </th>
                          <th scope="col" class="no-styles table-header">
                            Fecha creacion solicitud
                          </th>
                          <th scope="col" class="no-styles table-header">
                            Identificación beneficiario
                          </th>
                          <th scope="col" class="no-styles table-header">
                            Nombre beneificiario
                          </th>
                          <th scope="col" class="no-styles table-header">
                            Departamento
                          </th>
                          <th scope="col" class="no-styles table-header">
                            Ciudad
                          </th>
                          <th scope="col" class="no-styles table-header">Monto aprobado</th>
                          <th scope="col" class="no-styles table-header">Monto desembolsado</th>
                          <th scope="col" class="no-styles table-header">
                            Origen recursos
                          </th>
                          <th scope="col" class="no-styles table-header">Ver detalles</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (sol of solicitudes; track sol) {
                          <tr>
                            <td scope="row">
                              {{ sol.idSolicitud }}
                            </td>
                            <td>{{ sol.fechaCreacion | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                            <td>
                              {{ sol.tipoDocumento + " " + sol.numeroDocumento }}
                            </td>
                            <td>
                              {{ sol.nombreBeneficiario }}
                            </td>
                            <td>
                              {{ sol.departamento }}
                            </td>
                            <td>
                              {{ sol.ciudad }}
                            </td>
                            <td>
                              {{
                              sol.montoAprobado
                              ? (sol.montoAprobado / 1000
                              | currency: "$ ":"symbol":"2.3-3")
                              : "$ 0"
                              }}
                            </td>
                            <td>
                              {{
                              sol.montoFinal
                              ? (sol.montoFinal / 1000
                              | currency: "$ ":"symbol":"2.3-3")
                              : "$ 0"
                              }}
                            </td>
                            <td>
                              {{ sol.origenRecursos }}
                            </td>
                            <td>
                              <a
                  [routerLink]="[
                    '../detallePropuestaIF/verDetallePropuesta/',
                    sol.idSolicitud
                  ]" (click)="guardarFiltro()"
                                ><i class="fas fa-eye text-light"></i
                              ></a>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
              @if (consulta) {
                <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
                [totalPaginas]="totalPaginas"></app-pagination>
              }
              <!-- Modal -->
              <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-body justify-content-md-center">
                      <div class="row">
                        <div class="col-12 col-sm-12 me-3 ms-3">
                          <h2>No se encontraron operaciones con los criterios seleccionados</h2>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer justify-content-md-center">
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a id="downloadFile" style="display: none"></a>
            <div class="footer-body"></div>
          </div>
          <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
